import styled, { css, keyframes } from "styled-components";

const getBackgroundColorChip = (status) => {
  switch (status) {
    case "CONFIRM":
      return "#129768";
    case "EMPTY":
      return "#BDBDBD";
    case "MAYBE":
      return "#EF9952";
    case "REFUSE":
      return "#E11021";
    default:
      return "#002776";
  }
};

const getColorChip = (status) => {
  switch (status) {
    default:
      return "#ffffff";
  }
};

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slideIn = keyframes`
  from { opacity: 0; transform: translateX(-12px); }
  to { opacity: 1; transform: translateX(0); }
`;

export const Container = styled.div`
  min-width: 750px;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f2f8;
`;

export const TitleSection = styled.div`
  h2 {
    color: #031795;
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0 0 4px 0;
    letter-spacing: -0.02em;
  }

  p {
    color: #666;
    font-size: 0.875rem;
    margin: 0;
  }
`;

export const WrapperChip = styled.div`
  div {
    background-color: ${(props) => getBackgroundColorChip(props.status)};
    color: ${(props) => getColorChip(props.status)};
  }
  svg {
    color: ${(props) => getColorChip(props.status)};
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  color: #999;
  transition: all 0.2s ease;

  &:hover {
    background: #f5f5f5;
    color: #333;
  }

  svg {
    font-size: 1.25rem;
  }
`;

export const FilterSection = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;

  .filter-field {
    flex: 1;
    min-width: 180px;
  }

  .filter-actions {
    display: flex;
    align-items: flex-end;
    gap: 8px;
  }
`;

export const MeetingsTable = styled.div`
  width: 100%;
  max-height: 350px;
  overflow-y: auto;
  margin: 20px 0;
  border-radius: 4px;
  border: 1px solid #e8eaf6;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c5cae9;
    border-radius: 3px;
  }
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr 120px 140px 180px 100px;
  gap: 12px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #031795 0%, #1a2f9e 100%);
  color: #fff;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  position: sticky;
  top: 0;
  z-index: 2;

  div {
    display: flex;
    align-items: center;
  }

  .MuiCheckbox-root {
    color: rgba(255, 255, 255, 0.9);
    padding: 4px;

    &.Mui-checked, &.MuiCheckbox-indeterminate {
      color: #fff;
    }
  }
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr 120px 140px 180px 100px;
  gap: 12px;
  padding: 12px 16px;
  background: #fff;
  color: #333;
  border-bottom: 1px solid #f0f2f8;
  transition: all 0.15s ease;
  animation: ${slideIn} 0.25s ease-out;
  animation-fill-mode: both;
  animation-delay: ${props => props.$index * 0.03}s;
  font-size: 0.875rem;

  &:hover {
    background: #f8f9ff;
  }

  &:last-child {
    border-bottom: none;
  }

  ${props => props.$isSelected && css`
    background: #f0f4ff;

    &:hover {
      background: #e8edff;
    }
  `}

  div {
    display: flex;
    align-items: center;

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .MuiCheckbox-root {
    color: #c5cae9;
    padding: 4px;

    &.Mui-checked {
      color: #031795;
    }
  }
`;

export const SelectionSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #f8f9ff;
  margin-bottom: 20px;

  .count {
    font-size: 0.875rem;
    color: #555;

    strong {
      color: #031795;
      font-weight: 600;
    }
  }

  .select-all-btn {
    font-size: 0.8rem;
    color: #031795;
    background: transparent;
    border: none;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      color: #1a2f9e;
    }
  }
`;

export const FormSection = styled.div`
  margin-top: 24px;
  padding-top: 24px;
  border-top: 2px solid #f0f2f8;
`;

export const AttendeesSection = styled.div`
  margin-top: 16px;
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f8;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;

  p {
    margin-top: 16px;
    color: #666;
    font-size: 0.9rem;
  }
`;

export const EmptyState = styled.div`
  padding: 48px 24px;
  text-align: center;
  color: #999;

  svg {
    font-size: 3rem;
    color: #e0e0e0;
    margin-bottom: 16px;
  }

  p {
    font-size: 0.95rem;
    margin: 0;
  }
`;

export const InitialState = styled.div`
  padding: 48px 24px;
  text-align: center;
  color: #666;

  svg {
    font-size: 3rem;
    color: #c5cae9;
    margin-bottom: 16px;
  }

  p {
    font-size: 0.95rem;
    margin: 0 0 8px 0;
  }

  .hint {
    font-size: 0.85rem;
    color: #999;
  }
`;

export const TruncatedWarning = styled.div`
  padding: 10px 16px;
  margin-bottom: 16px;
  background: #fff3e0;
  border-radius: 4px;
  border: 1px solid #ffe0b2;
  color: #e65100;
  font-size: 0.875rem;
`;
